import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from '../../../helper/util/AuthContext';
import "./header.css";

const MenuItem = ({ label, href = "#" }) => (
  <a className="hn-menu-item" href={href}>
    {label}
  </a>
);

const menus = {
  "executive": [
    {"title": "Manage Lead", "url": "manage-lead"}
  ],
  "manager":[
    {"title": "Manage Lead", "url": "manage-lead"},
    {"title": "Register User", "url": "register"}
  ],
  "admin":[
    {"title": "Manage Lead", "url": "manage-lead"},
    {"title": "Register User", "url": "register"}
  ],
};


export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notifications, setNotifications] = useState(3);

  const { token, logout, user } = useContext(AuthContext);
  const navigate = useNavigate();

  const profileRef = useRef(null);
  const mobileRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
      if (mobileRef.current && !mobileRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(()=>{
    if(token)
    setIsAuthenticated(true);
  },[token])

  function toggleAuth(e) {
    let button = e.target.innerText;
    if(button === 'Logout'){
      logout();
      navigate("/login");
    }
    setIsAuthenticated((s) => !s);
    setProfileOpen(false);
  }

  function clearNotifications() {
    setNotifications(0);
  }

  return (
    <header className="hn-header">
      <div className="hn-left">
        <button
          className="hn-hamburger"
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((s) => !s)}
          ref={mobileRef}
        >
          <span className="hn-ham-line" />
          <span className="hn-ham-line" />
          <span className="hn-ham-line" />
        </button>

        <div className="hn-logo" aria-label="Site logo">
          {/* Replace with <img src="logo.png" alt="logo" /> if desired */}
          <img className="hn-logo-svg" src="/logo192-without-name.png" alt="logo" />
          <h4>Client Management Portal</h4>
        </div>
      </div>

      <div className="hn-menu-actions">
        <nav className={`hn-nav ${mobileOpen ? "open" : ""}`} aria-label="Primary">
          {menus[user?.role]?.map((m) => (
            <MenuItem key={m.title} label={m.title} href={`/${m.url.toLowerCase()}`} />
          ))}
        </nav>

        <div className="hn-actions">
          {/* <button
          className="hn-notif-btn"
          title="Notifications"
          aria-label="Notifications"
          onClick={() => {
            // Example behavior: clear notifications on click
            clearNotifications();
          }}
        >
          <svg className="hn-icon" width="20" height="20" viewBox="0 0 24 24" aria-hidden>
            <path fill="currentColor" d="M12 2a7 7 0 00-7 7v5H4a1 1 0 000 2h16a1 1 0 000-2h-1V9a7 7 0 00-7-7zm0 20a3 3 0 003-3H9a3 3 0 003 3z" />
          </svg>
          {notifications > 0 && <span className="hn-badge">{notifications}</span>}
        </button> */}

          <div className="hn-profile" ref={profileRef}>
            <button
              className="hn-profile-btn"
              aria-haspopup="true"
              aria-expanded={profileOpen}
              onClick={() => setProfileOpen((s) => !s)}
              title="Profile"
            >
              <svg className="hn-avatar" width="28" height="28" viewBox="0 0 24 24" aria-hidden>
                <circle cx="12" cy="8" r="3" fill="#0f172a" />
                <path fill="#0f172a" d="M4 20a8 8 0 0116 0z" />
              </svg>
            </button>

            {profileOpen && (
              <div className="hn-profile-menu" role="menu">
                {isAuthenticated && (
                  <>
                    <a className="hn-menu-action" href="/profile" role="menuitem">
                    Profile
                    </a>
                    <button className="hn-menu-action" onClick={toggleAuth} role="menuitem">
                      Logout
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
